import { useState } from 'react';
import type { IDocument } from '../../Interfaces/IDocument';
import {
  Dialog,
  DialogTitle,
  Box,
  IconButton,
  Typography,
} from '@mui/material';
import { Close, ZoomOut, ZoomIn } from '@mui/icons-material';
import { PdfDocument } from '../../Document/PdfDocument';

export const DocumentDialog = ({
  document,
  open,
  onClose,
}: {
  document: IDocument;
  open: boolean;
  onClose: () => void;
}) => {
  const [numPages, setNumPages] = useState(1);
  const [scale, setScale] = useState(1);
  const handleZoomIn = () => {
    setScale(prev => Math.min(prev + 0.25, 3));
  };

  const handleZoomOut = () => {
    setScale(prev => Math.max(prev - 0.25, 0.5));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pr: 1,
          borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        }}
      >
        <DialogTitle>{document.FileName}</DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton
              disabled={scale <= 0.5}
              onClick={handleZoomOut}
              aria-label='verkleinern'
              size='small'
            >
              <ZoomOut />
            </IconButton>
            <Typography sx={{ alignSelf: 'center' }}>
              {Math.round(scale * 100)}%
            </Typography>
            <IconButton
              disabled={scale >= 3}
              onClick={handleZoomIn}
              aria-label='vergrößern'
              size='small'
            >
              <ZoomIn />
            </IconButton>
          </Box>
          <IconButton onClick={onClose} aria-label='schließen'>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <Box sx={{ p: 2 }}>
        <Box sx={{ height: '70vh', overflow: 'auto' }}>
          {document.Data && (
            <PdfDocument
              pdfFile={`data:application/pdf;base64,${document.Data}`}
              numPages={numPages}
              pageNumber={1}
              scale={scale}
              setNumPages={setNumPages}
              scrollable
            />
          )}
        </Box>
      </Box>
    </Dialog>
  );
};
